.error {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &.compact {
    h1 {
      font: var(--font-body-large-regular);
    }
  }
}
